import * as React from 'react';
import * as ReactDOM from 'react-dom';

import Application from '@source/components/Application';
import '@source/styles/main.scss';

ReactDOM.render(
  <Application />,
  document.getElementById('root')
);
